(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["carrusel-product"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (root.dataset.ttInit === '1') return;
      root.dataset.ttInit = '1';

      var track  = root.querySelector('[data-track]');
      var slides = root.querySelectorAll('.tt-c__slide');
      var thumbs = root.querySelectorAll('[data-thumb]');
      var prev   = root.querySelector('[data-prev]');
      var next   = root.querySelector('[data-next]');
      var total  = slides.length;
      if (!track || total === 0) return;

      var loop = root.dataset.loop === 'true';
      var swipeOn = root.dataset.swipe === 'true';
      var shineOn = root.dataset.shine === 'true';
      var index = 0;

      function render() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        thumbs.forEach(function (t, i) {
          var active = i === index;
          t.classList.toggle('is-active', active);
          if (active && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      }
      function shine() {
        if (!shineOn) return;
        root.classList.remove('is-shining');
        void root.offsetWidth; // reinicia la animación
        root.classList.add('is-shining');
      }
      function goTo(i) {
        var old = index;
        if (loop) index = (i + total) % total;
        else index = Math.max(0, Math.min(i, total - 1));
        render();
        if (index !== old) shine();
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumb, 10)); }); });

      if (swipeOn) {
        var startX = 0, dx = 0, dragging = false, width = 0;
        var main = root.querySelector('.tt-c__main');
        function down(x) { dragging = true; startX = x; dx = 0; width = main.offsetWidth || 1; track.classList.add('is-dragging'); }
        function move(x) { if (!dragging) return; dx = x - startX; track.style.transform = 'translateX(' + (-index * 100 + (dx / width) * 100) + '%)'; }
        function up() { if (!dragging) return; dragging = false; track.classList.remove('is-dragging'); var th = width * 0.15; if (dx > th) goTo(index - 1); else if (dx < -th) goTo(index + 1); else render(); }
        track.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
        track.addEventListener('touchmove',  function (e) { move(e.touches[0].clientX); }, { passive: true });
        track.addEventListener('touchend', up);
        track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
        window.addEventListener('mousemove', function (e) { move(e.clientX); });
        window.addEventListener('mouseup', up);
      }

      render();
    }

    function initAll() {
      document.querySelectorAll('.tt-c').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
